import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Image from "gatsby-image"

function Bio() {
  return (
    <StaticQuery
      query={bioQuery}
      render={data => {
        const header = data.allMarkdownRemark.edges.filter(item => item.node.fileAbsolutePath.indexOf('header') >= 0)[0];
        const intro = data.allMarkdownRemark.edges.filter(item => item.node.fileAbsolutePath.indexOf('intro') >= 0)[0];
        const footer = data.allMarkdownRemark.edges.filter(item => item.node.fileAbsolutePath.indexOf('footer') >= 0)[0];

        return (
          <div className="bio-container">
            <div className="title-container">
              <h1 className="title">{header.node.frontmatter.name},<span className="title-span-black">&nbsp;{header.node.frontmatter.role}&nbsp;</span></h1>
              <div className="title-social">
                contact
                <a href={footer.node.frontmatter.twitter} target="_blank" rel="noopener noreferrer">
                  <Image
                    fixed={data.twitter.childImageSharp.fixed}
                    alt="twitter"
                  />
                </a>
                <a href={footer.node.frontmatter.linkedin} target="_blank" rel="noopener noreferrer">
                  <Image
                    fixed={data.linkedin.childImageSharp.fixed}
                    alt="linkedin"
                  />
                </a>
              </div>
            </div>
            <div className="title-container">
              <hr role="presentation"/>
            </div>
            <div dangerouslySetInnerHTML={{ __html: intro.node.html }} />

            {/* <Image
              fluid={data.intro.childImageSharp.fluid}
              alt={header.node.frontmatter.name}
            /> */}
          </div>
        )
      }}
    />
  )
}

export default Bio;

const bioQuery = graphql`
  query BioQuery {
    twitter: file(absolutePath: { regex: "/twitter.png/" }) {
      childImageSharp {
        fixed(width: 12, height: 11) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    linkedin: file(absolutePath: { regex: "/linkedin.png/" }) {
      childImageSharp {
        fixed(width: 12, height: 12) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    intro: file(absolutePath: { regex: "/intro.png/" }) {
      childImageSharp {
        fluid(maxWidth: 400, maxHeight: 350) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    allMarkdownRemark {
      edges {
        node {
          frontmatter {
            title
            description
            twitter
            linkedin
            email
            name
            role
          }
          fileAbsolutePath
          html
        }
      }
    }
  }
`
